import { render } from "./FeedbackReport.vue?vue&type=template&id=823e447a&scoped=true"
import script from "./FeedbackReport.vue?vue&type=script&lang=js"
export * from "./FeedbackReport.vue?vue&type=script&lang=js"

import "./FeedbackReport.vue?vue&type=style&index=0&id=823e447a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-823e447a"]])

export default __exports__